<template>
  <span>
    <i :id="targetId" class="btr bt-info-circle text-secondary"></i>
    <b-popover :target="targetId" triggers="hover click" placement="bottom">
      Please Note: We cannot 100% verify that the ingredients used by partner restaurants are as stated.
      If you have a strict dietary restriction, please understand that we have no control over kitchen conditions.
    </b-popover>
  </span>
</template>

<script>
export default {
  data() {
    return {
      targetId: `ingWarnTgt${Math.random()}`,
    }
  },
}
</script>
